import { object, string } from "prop-types";
import { observer } from "mobx-react";
import { useEstimateStructure } from "@tools";
import { getTimelineMonthWidth } from "@tools/EstimateEditor/utils";

export const TimelineScaffoldCell = observer(({ month }) => {
  const structure = useEstimateStructure();
  const width = getTimelineMonthWidth(
    month.weeks?.[0]?.startDate ?? month.startDate,
    structure.settings.timelineExpandedMonths,
  );

  return (
    <div
      className="h-full"
      style={{ width, minWidth: width }}
      aria-hidden="true"
    />
  );
});

TimelineScaffoldCell.propTypes = {
  month: object.isRequired,
  className: string,
};
